import { Link } from "@/components/LocalizedLink";
import { useTranslation } from "react-i18next";
import { useHydrated } from "@/hooks/useHydrated";
import i18n from "@/i18n";

export function SiteFooter() {
  const { t } = useTranslation();
  const hydrated = useHydrated();
  // Guiderna finns bara på svenska (SEO). SSR renderar alltid svenska, så de
  // visas tills hydreringen vet att besökaren valt ett annat språk.
  const showSvGuides = !hydrated || i18n.language?.startsWith("sv");
  return (

    <footer className="mt-24 border-t border-border bg-surface/40">
      <div className="container-page py-12 grid gap-8 md:grid-cols-2 lg:grid-cols-4 text-sm">
        <div>
          <div className="font-display text-lg font-semibold">{t("aFooter.brand")}</div>
          <p className="mt-2 text-muted-foreground max-w-xs">{t("aFooter.tagline")}</p>
        </div>
        <div>
          <div className="font-medium mb-3">{t("aFooter.product")}</div>
          <ul className="space-y-2 text-muted-foreground">
            <li><Link to="/practice" className="hover:text-foreground">{t("aFooter.links.practice")}</Link></li>
            <li><Link to="/exam" className="hover:text-foreground">{t("aFooter.links.exam")}</Link></li>
            <li><Link to="/pricing" className="hover:text-foreground">{t("aFooter.links.pricing")}</Link></li>
            <li><Link to="/dashboard" className="hover:text-foreground">{t("aFooter.links.myPage")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-medium mb-3">{t("aFooter.content")}</div>
          <ul className="space-y-2 text-muted-foreground">
            <li><Link to="/serveringstillstand-och-kunskapsprov" className="hover:text-foreground">{t("aFooter.links.guide")}</Link></li>
            <li><Link to="/kunskapsbank" className="hover:text-foreground">{t("aFooter.links.knowledgeBank")}</Link></li>
            {showSvGuides && (
              <>
                <li><Link to="/gratis-ovningsfragor-serveringstillstand" className="hover:text-foreground">Alkoholtillstånd prov gratis</Link></li>
                <li><Link to="/utbildning-serveringstillstand" className="hover:text-foreground">Utbildning serveringstillstånd</Link></li>
                <li><Link to="/serveringsansvarig" className="hover:text-foreground">Serveringsansvarig</Link></li>
                <li><Link to="/ansvarsfull-alkoholservering" className="hover:text-foreground">Ansvarsfull alkoholservering</Link></li>
                <li><Link to="/tillstandsenheten" className="hover:text-foreground">Tillståndsenheten</Link></li>
                <li><Link to="/serveringstillstand-slutet-sallskap" className="hover:text-foreground">Serveringstillstånd slutet sällskap</Link></li>
                <li><Link to="/utskankningstillstand" className="hover:text-foreground">Utskänkningstillstånd</Link></li>
              </>
            )}

            <li><Link to="/foretag" className="hover:text-foreground">{t("aFooter.links.forCompanies")}</Link></li>
            <li><Link to="/digitala-tjanster" className="hover:text-foreground">{t("aFooter.links.digitalServices")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-medium mb-3">{t("aFooter.company")}</div>
          <ul className="space-y-2 text-muted-foreground">
            <li><Link to="/faq" className="hover:text-foreground">{t("aFooter.links.faq")}</Link></li>
            <li><Link to="/installera" className="hover:text-foreground">{t("aFooter.links.install")}</Link></li>
            <li><Link to="/kontakt" className="hover:text-foreground">{t("aFooter.links.contact")}</Link></li>
            <li><Link to="/villkor" className="hover:text-foreground">{t("aFooter.links.terms")}</Link></li>
            <li><Link to="/integritetspolicy" className="hover:text-foreground">{t("aFooter.links.privacy")}</Link></li>
            <li><Link to="/radera-konto" className="hover:text-foreground">{t("aFooter.links.deleteAccount")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="container-page py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-muted-foreground">
          <div>{t("aFooter.copyright", { year: new Date().getFullYear() })}</div>
          <div className="max-w-xl text-balance">{t("aFooter.disclaimer")}</div>
        </div>
      </div>
    </footer>
  );
}
